import Resizer from "react-image-file-resizer";

export const imageFileResizer = Resizer.imageFileResizer;
